import {PhoneHQAvatar} from 'ch3-ui-lib';
import {useIntl} from 'react-intl';
import {groupCallMessages as m} from '../messages';
import {avatarStackLayout} from '../services/GroupCallHistoryPresentation';

export interface StackedParticipant {
    readonly displayName: string;
    readonly avatarUrl?: string;
}

// `compact` overlaps small faces so the stack fits a 48px list row.
export const ParticipantAvatarStack = ({participants, compact = false}: {participants: readonly StackedParticipant[]; compact?: boolean}) => {
    const intl = useIntl();
    const {shown, overflow} = avatarStackLayout(participants.length);
    return (
        <div
            data-testid="group-call-history-avatars"
            className={`flex items-center ${compact ? '-space-x-1.5' : ''}`}
            title={participants.map(participant => participant.displayName).join(', ')}
        >
            {participants.slice(0, shown).map((participant, index) => (
                <PhoneHQAvatar
                    key={`${participant.displayName}-${index}`}
                    name={participant.displayName}
                    src={participant.avatarUrl}
                    size={compact ? '20px' : '32px'}
                    className="ring-2 ring-surface"
                />
            ))}
            {overflow > 0 && (
                <span
                    data-testid="group-call-history-avatars-more"
                    aria-label={intl.formatMessage(m.historyMoreParticipants, {count: overflow})}
                    className={`relative inline-flex shrink-0 items-center justify-center bg-surface-muted font-medium text-ink-secondary ring-2 ring-surface ${compact ? 'size-5 rounded-md text-[10px]' : 'size-8 rounded-lg text-xs'}`}
                >
                    +{overflow}
                </span>
            )}
        </div>
    );
};
